module.exports = __webpack_public_path__ + "img/Q5-image.e028585d.png";